/**
 * 펀딩 에러
 */
export class FundingError extends Error {
  constructor(
    message: string,
    public status = 500,
  ) {
    super(message);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, FundingContractError);
    }
  }

  static is<T extends FundingContractError>(this: new (...args: any[]) => T, e: unknown): e is T {
    return e instanceof this;
  }
}

// 펀딩 상품이 아님
export class NotFundingError extends FundingError {
  constructor() {
    super('NotFundingError');

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NotFundingError);
    }
  }
}

/**
 * 펀딩 계약 에러
 */
export class FundingContractError extends Error {
  constructor(
    message: string,
    public status = 500,
  ) {
    super(message);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, FundingContractError);
    }
  }

  static is<T extends FundingContractError>(this: new (...args: any[]) => T, e: unknown): e is T {
    return e instanceof this;
  }
}

export class AlreadyExistFundingContractError extends FundingContractError {
  constructor() {
    super('AlreadyExistFundingOrderError');

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AlreadyExistFundingContractError);
    }
  }
}

export class NotExistFundingContractError extends FundingContractError {
  constructor() {
    super('NotExistFundingContractError');

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NotExistFundingContractError);
    }
  }
}

export class NotFundingContractError extends FundingContractError {
  constructor() {
    super('NotFundingContractError');

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NotFundingContractError);
    }
  }
}
